import PropTypes from "prop-types";
import { SubscriptionPage } from "vino/components";

const Block = ({ attributes }) => {
	return <SubscriptionPage attributes={attributes} />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
